import {
  ADMIN_DASHBOARD,
  ADMIN_COURSE_CATALOG,
  ADMIN_COURSE_ADD,
  ADMIN_SCORM_UPLOAD,
  ADMIN_AVATAR_LIBRARY,
  ADMIN_COURSE_CATEGORIES,
  ADMIN_COURSE_ASSIGNMENT,
  ADMIN_COURSE_ASSIGNMENT_ANALYTICS,
  ADMIN_CERTIFICATIONS,
  ADMIN_CERTIFICATION_CREATE,
  ADMIN_CERTIFICATION_ASSIGNMENT,
  ADMIN_CERTIFICATION_ASSIGNMENT_ANALYTICS,
  ADMIN_LEARNING_PATHS,
  ADMIN_LEARNING_PATH_CREATE,
  ADMIN_LP_WORKFLOW_LIST,
  ADMIN_LEARNING_PATH_ASSIGNMENT,
  ADMIN_LEARNING_PATH_ASSIGNMENT_ANALYTICS,
  ADMIN_USERS,
  ADMIN_USERS_INVITATIONS,
  ADMIN_USERS_DEPARTMENTS,
  ADMIN_ROLES,
  ADMIN_ANALYTICS,
  ADMIN_ANALYTICS_EMPLOYEE_PROGRESS,
  ADMIN_ANALYTICS_MY_TEAM_PROGRESS,
  ADMIN_ANALYTICS_DEPARTMENT_PROGRESS,
  ADMIN_ANALYTICS_ROLE_PROGRESS,
  ADMIN_ANALYTICS_COURSE_PERFORMANCE,
  ADMIN_ANALYTICS_LEARNING_PATH_PERFORMANCE,
  ADMIN_ANALYTICS_CERTIFICATION_PERFORMANCE,
  ADMIN_REPORTS_ACTIVITY,
  ADMIN_REPORTS_TRENDING,
  ADMIN_LEADERBOARD,
  ADMIN_GAMIFICATION_BADGES,
  ADMIN_GAMIFICATION_USER_ACHIEVEMENTS,
  ADMIN_REVIEWS,
  ADMIN_KNOWLEDGE_DOCUMENTS,
  ADMIN_SETTINGS_BUSINESS,
  ADMIN_SETTINGS_TICKET_REQUESTS,
  ADMIN_SETTINGS_WEBHOOKS,
  ADMIN_SETTINGS_AI_MODELS,
  ADMIN_SSO_CONFIGURATION,
  ADMIN_SCIM_CONFIGURATION,
  ADMIN_EMAIL_LOGS,
  ADMIN_TRAINING_STATUS_REPORT,
  ADMIN_EMAIL_TEMPLATES,
  ADMIN_CERTIFICATE_TEMPLATES,
  LEARNER_DASHBOARD,
  LEARNER_COURSES,
  LEARNER_LEARNING_PATHS,
  LEARNER_CERTIFICATIONS,
  LEARNER_SCHEDULE,
  LEARNER_TICKETS,
  LEARNER_LEADERBOARD,
  LEARNER_MY_ACHIEVEMENTS,
  LEARNER_HELP,
  ADMIN_REPORTS_AI_COST,
  ADMIN_AI_USAGE,
} from './constant-routes';

import {
  DASHBOARD_PERMISSION,
  COURSE_CATALOG_PERMISSION,
  COURSE_GENERATION_PERMISSION,
  SCORM_IMPORT_PERMISSION,
  AVATAR_LIBRARY_PERMISSION,
  CATEGORY_PERMISSION,
  TRENDING_TOPICS_PERMISSION,
  COURSE_ASSIGNMENT_PERMISSION,
  COURSE_ASSIGNMENT_ANALYTICS_PERMISSION,
  CERTIFICATION_CATALOG_PERMISSION,
  CERTIFICATION_CREATION_PERMISSION,
  CERTIFICATION_ASSIGNMENT_PERMISSION,
  CERTIFICATION_ASSIGNMENT_ANALYTICS_PERMISSION,
  LEARNING_PATH_CATALOG_PERMISSION,
  LEARNING_PATH_CREATION_PERMISSION,
  LEARNING_PATH_WORKFLOW_PERMISSION,
  LEARNING_PATH_ASSIGNMENT_PERMISSION,
  LEARNING_PATH_ASSIGNMENT_ANALYTICS_PERMISSION,
  USERS_PERMISSION,
  INVITE_MANAGEMENT_PERMISSION,
  GROUPS_PERMISSION,
  ROLES_PERMISSION,
  ANALYTICS_OVERVIEW_PERMISSION,
  EMPLOYEE_PROGRESS_PERMISSION,
  MY_TEAM_PROGRESS_PERMISSION,
  DEPARTMENT_PROGRESS_PERMISSION,
  ROLE_PROGRESS_PERMISSION,
  COURSE_PERFORMANCE_PERMISSION,
  LEARNING_PATH_PERFORMANCE_PERMISSION,
  CERTIFICATION_PERFORMANCE_PERMISSION,
  ACTIVITY_REPORT_PERMISSION,
  LEADERBOARD_PERMISSION,
  BADGE_MANAGEMENT_PERMISSION,
  USER_ACHIEVEMENTS_PERMISSION,
  REVIEWS_PERMISSION,
  DOCUMENT_STORE_PERMISSION,
  BUSINESS_SETTINGS_PERMISSION,
  AI_MODEL_SETTINGS_PERMISSION,
  TICKET_REQUESTS_PERMISSION,
  WEBHOOK_SETTINGS_PERMISSION,
  SSO_CONFIGURATION_PERMISSION,
  SCIM_CONFIGURATION_PERMISSION,
  EMAIL_LOGS_PERMISSION,
  TRAINING_STATUS_REPORT_PERMISSION,
  EMAIL_TEMPLATE_PERMISSION,
  CERTIFICATE_TEMPLATE_PERMISSION,
  LEARNER_DASHBOARD_PERMISSION,
  LEARNER_COURSES_PERMISSION,
  LEARNER_LEARNING_PATHS_PERMISSION,
  LEARNER_CERTIFICATIONS_PERMISSION,
  LEARNER_SCHEDULE_PERMISSION,
  LEARNER_TICKETS_PERMISSION,
  LEARNER_LEADERBOARD_PERMISSION,
  LEARNER_GAMIFICATION_PERMISSION,
  LEARNER_CONTACT_SUPPORT_PERMISSION,
  AI_COST_TRACKING_PERMISSION,
  AI_USAGE_PERMISSION,
} from './constant-permissions';

const permissionRoutes: Record<string, string> = {
  // ── Admin: Dashboard ──
  [DASHBOARD_PERMISSION.DASHBOARD_READ]: ADMIN_DASHBOARD,

  // ── Admin: Courses ──
  [COURSE_CATALOG_PERMISSION.COURSE_CATALOG_READ]: ADMIN_COURSE_CATALOG,
  [COURSE_CATALOG_PERMISSION.COURSE_CATALOG_WRITE]: ADMIN_COURSE_CATALOG,
  [COURSE_GENERATION_PERMISSION.COURSE_GENERATION_READ]: ADMIN_COURSE_ADD,
  [COURSE_GENERATION_PERMISSION.COURSE_GENERATION_WRITE]: ADMIN_COURSE_ADD,
  [SCORM_IMPORT_PERMISSION.SCORM_IMPORT_READ]: ADMIN_SCORM_UPLOAD,
  [SCORM_IMPORT_PERMISSION.SCORM_IMPORT_WRITE]: ADMIN_SCORM_UPLOAD,
  [AVATAR_LIBRARY_PERMISSION.AVATAR_LIBRARY_READ]: ADMIN_AVATAR_LIBRARY,
  [AVATAR_LIBRARY_PERMISSION.AVATAR_LIBRARY_WRITE]: ADMIN_AVATAR_LIBRARY,
  [CATEGORY_PERMISSION.CATEGORY_READ]: ADMIN_COURSE_CATEGORIES,
  [CATEGORY_PERMISSION.CATEGORY_WRITE]: ADMIN_COURSE_CATEGORIES,
  [TRENDING_TOPICS_PERMISSION.TRENDING_TOPICS_READ]: ADMIN_REPORTS_TRENDING,
  [TRENDING_TOPICS_PERMISSION.TRENDING_TOPICS_WRITE]: ADMIN_REPORTS_TRENDING,
  [COURSE_ASSIGNMENT_PERMISSION.COURSE_ASSIGNMENT_READ]: ADMIN_COURSE_ASSIGNMENT,
  [COURSE_ASSIGNMENT_PERMISSION.COURSE_ASSIGNMENT_WRITE]: ADMIN_COURSE_ASSIGNMENT,
  [COURSE_ASSIGNMENT_ANALYTICS_PERMISSION.COURSE_ASSIGNMENT_ANALYTICS_READ]: ADMIN_COURSE_ASSIGNMENT_ANALYTICS,
  [COURSE_ASSIGNMENT_ANALYTICS_PERMISSION.COURSE_ASSIGNMENT_ANALYTICS_WRITE]: ADMIN_COURSE_ASSIGNMENT_ANALYTICS,

  // ── Admin: Certifications ──
  [CERTIFICATION_CATALOG_PERMISSION.CERTIFICATION_CATALOG_READ]: ADMIN_CERTIFICATIONS,
  [CERTIFICATION_CATALOG_PERMISSION.CERTIFICATION_CATALOG_WRITE]: ADMIN_CERTIFICATIONS,
  [CERTIFICATION_CREATION_PERMISSION.CERTIFICATION_CREATION_READ]: ADMIN_CERTIFICATION_CREATE,
  [CERTIFICATION_CREATION_PERMISSION.CERTIFICATION_CREATION_WRITE]: ADMIN_CERTIFICATION_CREATE,
  [CERTIFICATION_ASSIGNMENT_PERMISSION.CERTIFICATION_ASSIGNMENT_READ]: ADMIN_CERTIFICATION_ASSIGNMENT,
  [CERTIFICATION_ASSIGNMENT_PERMISSION.CERTIFICATION_ASSIGNMENT_WRITE]: ADMIN_CERTIFICATION_ASSIGNMENT,
  [CERTIFICATION_ASSIGNMENT_ANALYTICS_PERMISSION.CERTIFICATION_ASSIGNMENT_ANALYTICS_READ]: ADMIN_CERTIFICATION_ASSIGNMENT_ANALYTICS,
  [CERTIFICATION_ASSIGNMENT_ANALYTICS_PERMISSION.CERTIFICATION_ASSIGNMENT_ANALYTICS_WRITE]: ADMIN_CERTIFICATION_ASSIGNMENT_ANALYTICS,

  // ── Admin: Learning Paths ──
  [LEARNING_PATH_CATALOG_PERMISSION.ADMIN_LEARNING_PATH_CATALOG_READ]: ADMIN_LEARNING_PATHS,
  [LEARNING_PATH_CATALOG_PERMISSION.ADMIN_LEARNING_PATH_CATALOG_WRITE]: ADMIN_LEARNING_PATHS,
  [LEARNING_PATH_CREATION_PERMISSION.ADMIN_LEARNING_PATH_CREATION_READ]: ADMIN_LEARNING_PATH_CREATE,
  [LEARNING_PATH_CREATION_PERMISSION.ADMIN_LEARNING_PATH_CREATION_WRITE]: ADMIN_LEARNING_PATH_CREATE,
  [LEARNING_PATH_WORKFLOW_PERMISSION.ADMIN_LEARNING_PATH_WORKFLOW_READ]: ADMIN_LP_WORKFLOW_LIST,
  [LEARNING_PATH_WORKFLOW_PERMISSION.ADMIN_LEARNING_PATH_WORKFLOW_WRITE]: ADMIN_LP_WORKFLOW_LIST,
  [LEARNING_PATH_ASSIGNMENT_PERMISSION.ADMIN_LEARNING_PATH_ASSIGNMENT_READ]: ADMIN_LEARNING_PATH_ASSIGNMENT,
  [LEARNING_PATH_ASSIGNMENT_PERMISSION.ADMIN_LEARNING_PATH_ASSIGNMENT_WRITE]: ADMIN_LEARNING_PATH_ASSIGNMENT,
  [LEARNING_PATH_ASSIGNMENT_ANALYTICS_PERMISSION.ADMIN_LEARNING_PATH_ASSIGNMENT_ANALYTICS_READ]: ADMIN_LEARNING_PATH_ASSIGNMENT_ANALYTICS,
  [LEARNING_PATH_ASSIGNMENT_ANALYTICS_PERMISSION.ADMIN_LEARNING_PATH_ASSIGNMENT_ANALYTICS_WRITE]: ADMIN_LEARNING_PATH_ASSIGNMENT_ANALYTICS,

  // ── Admin: User Management ──
  [USERS_PERMISSION.ADMIN_USERS_READ]: ADMIN_USERS,
  [USERS_PERMISSION.ADMIN_USERS_WRITE]: ADMIN_USERS,
  [INVITE_MANAGEMENT_PERMISSION.ADMIN_INVITE_MANAGEMENT_READ]: ADMIN_USERS_INVITATIONS,
  [INVITE_MANAGEMENT_PERMISSION.ADMIN_INVITE_MANAGEMENT_WRITE]: ADMIN_USERS_INVITATIONS,
  [GROUPS_PERMISSION.ADMIN_GROUPS_READ]: ADMIN_USERS_DEPARTMENTS,
  [GROUPS_PERMISSION.ADMIN_GROUPS_WRITE]: ADMIN_USERS_DEPARTMENTS,
  [ROLES_PERMISSION.ADMIN_ROLES_READ]: ADMIN_ROLES,
  [ROLES_PERMISSION.ADMIN_ROLES_WRITE]: ADMIN_ROLES,

  // ── Admin: Analytics & Performance ──
  [ANALYTICS_OVERVIEW_PERMISSION.ADMIN_COURSE_ANALYTICS_READ]: ADMIN_ANALYTICS,
  [ANALYTICS_OVERVIEW_PERMISSION.ADMIN_CERTIFICATION_ANALYTICS_READ]: ADMIN_ANALYTICS,
  [EMPLOYEE_PROGRESS_PERMISSION.ADMIN_EMPLOYEE_PROGRESS_READ]: ADMIN_ANALYTICS_EMPLOYEE_PROGRESS,
  [EMPLOYEE_PROGRESS_PERMISSION.ADMIN_EMPLOYEE_PROGRESS_WRITE]: ADMIN_ANALYTICS_EMPLOYEE_PROGRESS,
  [MY_TEAM_PROGRESS_PERMISSION.ADMIN_MY_TEAM_PROGRESS_READ]: ADMIN_ANALYTICS_MY_TEAM_PROGRESS,
  [MY_TEAM_PROGRESS_PERMISSION.ADMIN_MY_TEAM_PROGRESS_WRITE]: ADMIN_ANALYTICS_MY_TEAM_PROGRESS,
  [DEPARTMENT_PROGRESS_PERMISSION.ADMIN_DEPARTMENT_PROGRESS_READ]: ADMIN_ANALYTICS_DEPARTMENT_PROGRESS,
  [DEPARTMENT_PROGRESS_PERMISSION.ADMIN_DEPARTMENT_PROGRESS_WRITE]: ADMIN_ANALYTICS_DEPARTMENT_PROGRESS,
  [ROLE_PROGRESS_PERMISSION.ADMIN_ROLE_PROGRESS_READ]: ADMIN_ANALYTICS_ROLE_PROGRESS,
  [ROLE_PROGRESS_PERMISSION.ADMIN_ROLE_PROGRESS_WRITE]: ADMIN_ANALYTICS_ROLE_PROGRESS,
  [COURSE_PERFORMANCE_PERMISSION.ADMIN_COURSE_PERFORMANCE_READ]: ADMIN_ANALYTICS_COURSE_PERFORMANCE,
  [COURSE_PERFORMANCE_PERMISSION.ADMIN_COURSE_PERFORMANCE_WRITE]: ADMIN_ANALYTICS_COURSE_PERFORMANCE,
  [LEARNING_PATH_PERFORMANCE_PERMISSION.ADMIN_LEARNING_PATH_PERFORMANCE_READ]: ADMIN_ANALYTICS_LEARNING_PATH_PERFORMANCE,
  [LEARNING_PATH_PERFORMANCE_PERMISSION.ADMIN_LEARNING_PATH_PERFORMANCE_WRITE]: ADMIN_ANALYTICS_LEARNING_PATH_PERFORMANCE,
  [CERTIFICATION_PERFORMANCE_PERMISSION.ADMIN_CERTIFICATION_PERFORMANCE_READ]: ADMIN_ANALYTICS_CERTIFICATION_PERFORMANCE,
  [CERTIFICATION_PERFORMANCE_PERMISSION.ADMIN_CERTIFICATION_PERFORMANCE_WRITE]: ADMIN_ANALYTICS_CERTIFICATION_PERFORMANCE,
  [ACTIVITY_REPORT_PERMISSION.ADMIN_ACTIVITY_REPORT_READ]: ADMIN_REPORTS_ACTIVITY,
  [ACTIVITY_REPORT_PERMISSION.ADMIN_ACTIVITY_REPORT_WRITE]: ADMIN_REPORTS_ACTIVITY,

  // ── Admin: Gamification ──
  [LEADERBOARD_PERMISSION.ADMIN_LEADERBOARD_READ]: ADMIN_LEADERBOARD,
  [BADGE_MANAGEMENT_PERMISSION.ADMIN_BADGE_MANAGEMENT_READ]: ADMIN_GAMIFICATION_BADGES,
  [BADGE_MANAGEMENT_PERMISSION.ADMIN_BADGE_MANAGEMENT_WRITE]: ADMIN_GAMIFICATION_BADGES,
  [USER_ACHIEVEMENTS_PERMISSION.ADMIN_USER_ACHIEVEMENTS_READ]: ADMIN_GAMIFICATION_USER_ACHIEVEMENTS,

  // ── Admin: Reviews ──
  [REVIEWS_PERMISSION.ADMIN_REVIEWS_MANAGEMENT_READ]: ADMIN_REVIEWS,
  [REVIEWS_PERMISSION.ADMIN_REVIEWS_MANAGEMENT_WRITE]: ADMIN_REVIEWS,

  // ── Admin: Knowledge / Documents ──
  [DOCUMENT_STORE_PERMISSION.ADMIN_DOCUMENT_STORE_READ]: ADMIN_KNOWLEDGE_DOCUMENTS,
  [DOCUMENT_STORE_PERMISSION.ADMIN_DOCUMENT_STORE_WRITE]: ADMIN_KNOWLEDGE_DOCUMENTS,

  // ── Admin: Settings ──
  [BUSINESS_SETTINGS_PERMISSION.ADMIN_BUSINESS_SETTINGS_READ]: ADMIN_SETTINGS_BUSINESS,
  [BUSINESS_SETTINGS_PERMISSION.ADMIN_BUSINESS_SETTINGS_WRITE]: ADMIN_SETTINGS_BUSINESS,
  [TICKET_REQUESTS_PERMISSION.ADMIN_TICKET_REQUESTS_READ]: ADMIN_SETTINGS_TICKET_REQUESTS,
  [TICKET_REQUESTS_PERMISSION.ADMIN_TICKET_REQUESTS_WRITE]: ADMIN_SETTINGS_TICKET_REQUESTS,
  [WEBHOOK_SETTINGS_PERMISSION.ADMIN_WEBHOOK_SETTINGS_READ]: ADMIN_SETTINGS_WEBHOOKS,
  [WEBHOOK_SETTINGS_PERMISSION.ADMIN_WEBHOOK_SETTINGS_WRITE]: ADMIN_SETTINGS_WEBHOOKS,
  [AI_MODEL_SETTINGS_PERMISSION.ADMIN_AI_MODEL_SETTINGS_READ]: ADMIN_SETTINGS_AI_MODELS,
  [AI_MODEL_SETTINGS_PERMISSION.ADMIN_AI_MODEL_SETTINGS_WRITE]: ADMIN_SETTINGS_AI_MODELS,
  [AI_COST_TRACKING_PERMISSION.ADMIN_AI_COST_TRACKING_READ]: ADMIN_REPORTS_AI_COST,
  [AI_COST_TRACKING_PERMISSION.ADMIN_AI_COST_TRACKING_WRITE]: ADMIN_REPORTS_AI_COST,
  [AI_USAGE_PERMISSION.ADMIN_AI_USAGE_READ]: ADMIN_AI_USAGE,
  [AI_USAGE_PERMISSION.ADMIN_AI_USAGE_WRITE]: ADMIN_AI_USAGE,

  // ── Admin: Enterprise ──
  [SSO_CONFIGURATION_PERMISSION.ADMIN_SSO_CONFIGURATION_READ]: ADMIN_SSO_CONFIGURATION,
  [SSO_CONFIGURATION_PERMISSION.ADMIN_SSO_CONFIGURATION_WRITE]: ADMIN_SSO_CONFIGURATION,
  [SCIM_CONFIGURATION_PERMISSION.ADMIN_SCIM_CONFIGURATION_READ]: ADMIN_SCIM_CONFIGURATION,
  [SCIM_CONFIGURATION_PERMISSION.ADMIN_SCIM_CONFIGURATION_WRITE]: ADMIN_SCIM_CONFIGURATION,

  // ── Admin: Email Logs ──
  [EMAIL_LOGS_PERMISSION.ADMIN_EMAIL_LOGS_READ]: ADMIN_EMAIL_LOGS,

  // ── Admin: Training Status Report ──
  [TRAINING_STATUS_REPORT_PERMISSION.ADMIN_TRAINING_STATUS_REPORT_READ]: ADMIN_TRAINING_STATUS_REPORT,
  [TRAINING_STATUS_REPORT_PERMISSION.ADMIN_TRAINING_STATUS_REPORT_WRITE]: ADMIN_TRAINING_STATUS_REPORT,

  // ── Admin: Templates ──
  [EMAIL_TEMPLATE_PERMISSION.ADMIN_EMAIL_TEMPLATE_READ]: ADMIN_EMAIL_TEMPLATES,
  [EMAIL_TEMPLATE_PERMISSION.ADMIN_EMAIL_TEMPLATE_WRITE]: ADMIN_EMAIL_TEMPLATES,
  [CERTIFICATE_TEMPLATE_PERMISSION.ADMIN_CERTIFICATE_TEMPLATE_READ]: ADMIN_CERTIFICATE_TEMPLATES,
  [CERTIFICATE_TEMPLATE_PERMISSION.ADMIN_CERTIFICATE_TEMPLATE_WRITE]: ADMIN_CERTIFICATE_TEMPLATES,

  // ── Learner ──
  [LEARNER_DASHBOARD_PERMISSION.LEARNER_DASHBOARD_READ]: LEARNER_DASHBOARD,
  [LEARNER_COURSES_PERMISSION.LEARNER_COURSES_READ]: LEARNER_COURSES,
  [LEARNER_COURSES_PERMISSION.LEARNER_COURSES_WRITE]: LEARNER_COURSES,
  [LEARNER_LEARNING_PATHS_PERMISSION.LEARNER_LEARNING_PATHS_READ]: LEARNER_LEARNING_PATHS,
  [LEARNER_LEARNING_PATHS_PERMISSION.LEARNER_LEARNING_PATHS_WRITE]: LEARNER_LEARNING_PATHS,
  [LEARNER_CERTIFICATIONS_PERMISSION.LEARNER_CERTIFICATIONS_READ]: LEARNER_CERTIFICATIONS,
  [LEARNER_CERTIFICATIONS_PERMISSION.LEARNER_CERTIFICATIONS_WRITE]: LEARNER_CERTIFICATIONS,
  [LEARNER_SCHEDULE_PERMISSION.LEARNER_SCHEDULE_READ]: LEARNER_SCHEDULE,
  [LEARNER_TICKETS_PERMISSION.LEARNER_TICKETS_READ]: LEARNER_TICKETS,
  [LEARNER_TICKETS_PERMISSION.LEARNER_TICKETS_WRITE]: LEARNER_TICKETS,
  [LEARNER_LEADERBOARD_PERMISSION.LEARNER_LEADERBOARD_READ]: LEARNER_LEADERBOARD,
  [LEARNER_GAMIFICATION_PERMISSION.LEARNER_GAMIFICATION_READ]: LEARNER_MY_ACHIEVEMENTS,
  [LEARNER_GAMIFICATION_PERMISSION.LEARNER_GAMIFICATION_WRITE]: LEARNER_MY_ACHIEVEMENTS,
  [LEARNER_CONTACT_SUPPORT_PERMISSION.LEARNER_CONTACT_SUPPORT_READ]: LEARNER_HELP,
  [LEARNER_CONTACT_SUPPORT_PERMISSION.LEARNER_CONTACT_SUPPORT_WRITE]: LEARNER_HELP,
};

export const getAvailableRoute = (permissions: string[], routePrefix?: string): string | null => {
  for (const permission in permissionRoutes) {
    if (permissions.includes(permission)) {
      const route = permissionRoutes[permission];
      if (!routePrefix || route.startsWith(routePrefix)) {
        return route;
      }
    }
  }
  return null;
};

export default permissionRoutes;
